<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  color?: any
  symbol?: boolean
}>()

const background_color = computed(() => {
  return !props.symbol ? props.color : { color: '#FFFFFF' }
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="background_color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <path
      d="m11.159,33.807c-9.006,-3.503 -13.466,-13.64 -9.966,-22.647c3.503,-9.007 13.644,-13.47 22.648,-9.964c9.006,3.498 13.466,13.642 9.966,22.645c-3.503,9.008 -13.644,13.467 -22.648,9.966"
    />
    <line
      fill="none"
      y2="1.74983"
      x2="-1.68733"
      y1="1.74983"
      x1="-1.62483"
      stroke="#000000"
    />
    <rect
      fill="white"
      x="12.13994"
      y="13.85302"
      width="10.99087"
      height="14.5968"
      rx="1"
      stroke="null"
    />
    <ellipse
      :fill="background_color.color"
      cx="21.33231"
      cy="23.79057"
      rx="0.93256"
      ry="0.91063"
      stroke="null"
    />
    <ellipse
      :fill="background_color.color"
      cx="21.3323"
      cy="21.14975"
      rx="0.93256"
      ry="0.91063"
      stroke="null"
    />
    <ellipse
      :fill="background_color.color"
      cx="21.33231"
      cy="26.43139"
      rx="0.93256"
      ry="0.91063"
      stroke="null"
    />
    <line
      fill="none"
      stroke="#ffffff"
      x1="9.26046"
      y1="9.22773"
      x2="26.01028"
      y2="9.16523"
    />
    <line
      transform="rotate(90 17.6355 11.5715)"
      fill="none"
      x1="15.1979"
      y1="11.60271"
      x2="20.07284"
      y2="11.54021"
      stroke="#ffffff"
    />
    <ellipse
      fill="#ffffff"
      cx="26.16652"
      cy="9.13398"
      rx="0.84374"
      ry="0.90624"
      stroke="#ffffff"
    />
    <path
      fill="#ffffff"
      d="m5.11474,9.36268l0,0c0,-1.5533 1.24521,-2.8125 2.78125,-2.8125l0,0c0.73763,0 1.44506,0.29632 1.96664,0.82376c0.52159,0.52745 0.81461,1.24282 0.81461,1.98874l0,0c0,1.5533 -1.24521,2.8125 -2.78125,2.8125l0,0c-1.53604,0 -2.78125,-1.2592 -2.78125,-2.8125zm1.39063,0l0,0c0,0.77665 0.6226,1.40625 1.39063,1.40625c0.76802,0 1.39063,-0.6296 1.39063,-1.40625c0,-0.77665 -0.6226,-1.40625 -1.39063,-1.40625l0,0c-0.76802,0 -1.39063,0.6296 -1.39063,1.40625z"
    />
    <path
      id="svg_13"
      :stroke="background_color.color"
      d="m4.85594,9.28663l0.40625,-3.125l1.625,0c0.22437,0 0.40625,1.39911 0.40625,3.125c0,1.72587 -0.18189,3.125 -0.40625,3.125l-1.625,0l-0.40625,-3.125z"
      :fill="background_color.color"
    />
  </svg>
</template>
